/**
 * simple-icons brand pack — mapping semantic name → simple-icons slug.
 *
 * Rozsah:
 * - payment-brand kategorie (Visa, Mastercard, PayPal, Amex, Google Pay, Apple Pay, Stripe)
 * - social kategorie (Facebook, Instagram, YouTube, TikTok, LinkedIn, X, Spotify, Pinterest)
 *
 * Jak to funguje:
 * - simple-icons npm package exportuje ikony jako `siVisa`, `siFacebook`, atd.
 * - Každá má `{ title, slug, hex, path, svg }`
 * - Pro browser/CDN use je nejjednodušší použít `https://cdn.simpleicons.org/{slug}` jako img src
 *
 * Komentář u každé ikony:
 * - Oficiální brand barva (hex), kterou pack vrátí jako preserveColor
 * - Použijte buď `path` (pro inline SVG) nebo CDN URL
 *
 * ⚠️ NIKDY NEPŘEBARVOVAT — licence vyžaduje oficiální barvy.
 */

export const SIMPLE_ICONS_MAP: Record<string, string> = {
    // =====================================================================
    // payment-brand — platební karty a služby
    // =====================================================================
    'brand-visa': 'visa', // siVisa, hex #1A1F71 (official blue)
    'brand-mastercard': 'mastercard', // siMastercard, hex #EB001B (red)
    'brand-paypal': 'paypal', // siPaypal, hex #00457C
    'brand-amex': 'americanexpress', // siAmericanexpress, hex #2E77BC
    'brand-google-pay': 'googlepay', // siGooglepay, multi-color
    'brand-apple-pay': 'applepay', // siApplepay, hex #000000
    'brand-stripe': 'stripe', // siStripe, hex #635BFF

    // =====================================================================
    // social — sociální sítě
    // =====================================================================
    'social-facebook': 'facebook', // siFacebook, hex #0866FF
    'social-instagram': 'instagram', // siInstagram, hex #E4405F
    'social-youtube': 'youtube', // siYoutube, hex #FF0000
    'social-tiktok': 'tiktok', // siTiktok, hex #000000
    'social-linkedin': 'linkedin', // siLinkedin, hex #0A66C2
    'social-x': 'x', // siX (new Twitter logo), hex #000000
    'social-spotify': 'spotify', // siSpotify, hex #1ED760
    'social-pinterest': 'pinterest', // siPinterest, hex #BD081C
};
